import { cn, Typography } from "@suraasa/placebo-ui"
import { getProductImage } from "features/LearningItems/getProductDisplayConfig"
import { Lock } from "iconoir-react"

const CourseCards = ({
  className,
  isMini,
  slug,
}: {
  className?: string
  isMini?: boolean
  slug: string
}) => {
  const productImage = getProductImage({
    slug: slug,
    defaultImage: null,
  })

  if (isMini) {
    return (
      <div
        className={cn(
          "flex flex-col rounded-lg bg-[linear-gradient(180deg,#4A5671_0%,rgba(74,86,113,0)_81.45%)] p-2",
          className
        )}
      >
        {productImage && (
          <img
            src={productImage}
            alt={slug}
            className="mb-1 size-[38px] shrink-0 overflow-hidden rounded-xl"
          />
        )}
        <div>
          <Typography className="mb-1 max-w-[165px] text-[10px] font-semibold leading-[100%] tracking-[-2%] text-[#ADC6E0]">
            Professional Graduate Certificate in Teaching & Learning
          </Typography>
          <div className="flex items-center text-[#8FD6FA]">
            <Lock className="size-1.5" strokeWidth={1.5} />
            <Typography className="text-[8.46px] font-semibold uppercase leading-[100%] tracking-[4%]">
              Locked
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn(
        "flex flex-row-reverse gap-1 rounded-lg bg-[linear-gradient(180deg,#4A5671_0%,rgba(74,86,113,0)_81.45%)] p-2",
        className
      )}
    >
      {productImage && (
        <img
          src={productImage}
          alt={slug}
          className="size-[38px] shrink-0 overflow-hidden rounded-xl"
        />
      )}
      <div>
        <Typography className="mb-1 max-w-[165px] text-[10px] font-semibold leading-[100%] tracking-[-2%] text-[#ADC6E0]">
          Professional Graduate Certificate in Teaching & Learning
        </Typography>
        <div className="flex items-center gap-[1.5px] text-[#8FD6FA]">
          <Lock className="size-1.5" strokeWidth={1.5} />
          <Typography className="text-[8.46px] font-semibold uppercase leading-[100%] tracking-[4%]">
            Locked
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default CourseCards
